import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="text-xl font-heading font-semibold text-background-50">
                亲密指南
              </span>
            </Link>
            <p className="mt-4 text-sm text-background-400 leading-relaxed">
              以科学和尊重为基础，传播专业、可靠的性健康知识，帮助成年伴侣提升亲密关系质量。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/jiqiao" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">口交技巧</Link></li>
              <li><Link to="/category/anquan" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">安全防护</Link></li>
              <li><Link to="/category/weisheng" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">卫生与健康</Link></li>
              <li><Link to="/category/goutong" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">沟通与心理</Link></li>
              <li><Link to="/category/xingjiankang" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">性健康知识</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">核心价值</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              声明
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              本站内容仅供成年读者教育参考，不构成医疗建议。如有健康疑虑，请咨询专业医生。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} 亲密指南. 本站内容仅供18岁以上成年读者访问。
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors text-sm cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors text-sm cursor-pointer" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}